import React from "react";

const PageNotFound = () => {
  return (
    <div className="page-not-found-container">
      <div className="pnf-body">
        <h1>404</h1>
        <h1>OOPS! Page not found</h1>
        <p>Sorry, the page you are looking for does not exist.</p>
      </div>
    </div>
  );
};

export default PageNotFound;
